module.exports = __webpack_public_path__ + "img/pdf1.6f8593cf.png";